export const ID = 'f528c457-97ef-4192-9f05-447ef2f2e39b';

export const NAME = 'Unit Sizes: Categories / Links';
